
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/[cartUrl]/staff-login",
      function () {
        return require("private-next-pages/store/[cartUrl]/staff-login/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/[cartUrl]/staff-login"])
      });
    }
  